export enum PackageDealTab {
	SERVICES = 'SERVICES',
	PACKAGES = 'PACKAGES'
}
